import React from 'react';
import styled from 'styled-components';

const WrapperStyled = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  padding: 18px;

  h4 {
    margin: 0 0 12px;
    font-size: 16px;
    font-weight: 600;
  }

  .items-list {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    grid-gap: 10px;
    align-items: start;

    @media (max-width: 900px) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media (max-width: 560px) {
      grid-template-columns: 1fr;
    }
  }

  .ag-item {
    background: rgba(255, 255, 255, 0.025);
    border: 1px solid rgba(255, 255, 255, 0.05);
    border-radius: 6px;
    display: grid;
    justify-items: left;
    padding: 10px 12px;
  }

  .ag-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 3px 10px;
    justify-items: left;
    width: 100%;

    @media (max-width: 560px) {
      grid-template-columns: 1fr;
    }
  }

  label {
    color: rgba(255, 255, 255, 0.86);
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 8px;
  }

  .ag-item-2 {
    color: rgba(255, 255, 255, 0.58);
    font-size: 12px;
    line-height: 1.35;
    padding: 0;
  }
`;

const ServerAgentCollected = () => {
    return (
        <WrapperStyled>
            <h4>Monitored Data</h4>
            <div className="items-list">
                { _LIST.map((item, idx) => {
                    return (
                        <div
                            key={ 'ddzea414' + idx }
                            className="ag-item">
                            <label>
                                { item.group }
                            </label>

                            <div className="ag-list">
                                { item.list.map((agItem, idx2) => {
                                    return (
                                        <div
                                            key={ 'zdiiiawd' + idx2 }
                                            className="ag-item-2">
                                            { agItem }
                                        </div>
                                    );
                                }) }
                            </div>
                        </div>
                    );
                }) }
            </div>
        </WrapperStyled>
    );
};

export default ServerAgentCollected;

const _LIST = [
    {
        group: 'System',
        list: ['System uptime', 'System load', 'IO load']
    },
    {
        group: 'OS',
        list: [
            'OS kernel',
            'OS name',
            'OS architecture']
    },
    {
        group: 'CPU',
        list: ['CPU identifier', 'CPU cores', 'CPU frequency', 'CPU load']
    },
    {
        group: 'Process',
        list: [
            'Process count',
            'Process array']
    },
    {
        group: 'RAM',
        list: [
            'RAM total',
            'RAM usage',
            'SWAP total',
            'SWAP usage']
    },
    {
        group: 'Disk',
        list: [
            'Disk array',
            'Disk total',
            'Disk usage']
    },
    {
        group: 'Network',
        list: [
            'Connection count',
            'NIC identifier',
            'IPv4 address',
            'IPv6 address',
            'RX since boot',
            'TX since boot',
            'RX currently',
            'TX currently']
    },
    {
        group: 'File',
        list: [
            'File handle count',
            'File handle limit']
    },
    {
        group: 'Misc',
        list: [
            'Agent version',
            'Session count']
    }

];
